<template>
	<div class="pb-2 w-full">
		<div class="text-sm text-black gradient flex w-full justify-between px-4 py-3 md:px-8 xl:px-16">
			<!-- padding-left 12 is to compensate for the button with the w-8 and the px-4 on the parent div, allowing the banner text to be centered -->
			<div class="flex flex-grow flex-col pl-10 md:pl-8 md:flex-row space-y-3 md:space-y-0 md:space-x-4 items-center justify-center">
				<button class="bg-magnolia-300 px-3 py-2 md:py-1 rounded-lg shadow-lg font-semibold text-center text-xs md:text-sm">
					<router-link to="/categories/spring-favorites/">Springtime Savings Are Live!</router-link>
				</button>
				<router-link class="underline hover:text-ihh-dark-salmon text-center text-xs md:text-sm" to="/categories/spring-favorites/">
					Enjoy Up To 10% Off use code: SPRINGSAVINGS
				</router-link>
			</div>
			<button @click="hideBanner" class="w-8 md:block flex" type="button" title="Close">
				<div class="m-auto items-center flex w-full justify-end">
					<div class="rotate-45 absolute bg-ihh-slate-gray group-hover:bg-ihh-white py-[1px] px-2"></div>
					<div class="-rotate-45 bg-ihh-slate-gray group-hover:bg-ihh-white py-[1px] px-2"></div>
				</div>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SpringSaleBanner',
	emits: ['hide-banner'],
	methods: {
		hideBanner() {
			this.$emit('hide-banner')
		},
	},
}
</script>

<style scoped></style>
